// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".security-statement p[data-v-1e07190f]{line-height:16px}@media (max-width: 360px){.security-statement[data-v-1e07190f]{margin:2rem !important}}\n", ""]);
// Exports
module.exports = exports;
